export const useValidateRules = {
	empty: {
		validate($field: HTMLInputElement | HTMLTextAreaElement): boolean {
			return $field.value.length > 0;
		},
	},
	text: {
		validate($field: HTMLInputElement): boolean {
			return $field.value.length > 0 && $field.value.length <= 50;
		},
	},
	name: {
		validate($field: HTMLInputElement): boolean {
			const { value } = $field;
			return value.match(/^[A-Za-zА-Яа-яЁё ]+$/) && (value.length > 1 && value.length <= 50);
		},
	},
	email: {
		validate($field: HTMLInputElement): boolean {
			const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
			return reg.test(String($field.value).toLowerCase());
		},
	},
	password: {
		validate($field: HTMLInputElement): boolean {
			return $field.value.length > 7 && $field.value.length <= 20;
		},
	},
	textarea: {
		validate($field: HTMLTextAreaElement): boolean {
			return $field.value.length > 1 && $field.value.length <= 1000;
		},
	},
	conform: {
		validate($field: HTMLInputElement): boolean {
			const sample: HTMLInputElement | undefined = document.querySelector(
				$field.dataset.conform,
			);
			const value = sample?.value || '';
			return $field.value === value;
		},
	},
	mask: {
		validate($field: any): boolean {
			return $field.inputmask?.isComplete();
		},
	},
	tel: {
		validate($field: any): boolean {
			return $field.inputmask?.isComplete();
		},
	},
	date: {
		validate($field: any): boolean {
			return $field.inputmask?.isComplete();
		},
	},
	contactsComment: {
		validate: ($field: any): boolean => {
			return $field.value.length > 1 && $field.value.length <= 3000;
		}
	},
	code: {
		validate: ($field: any): boolean => $field.inputmask?.isComplete(),
	},
	address: {
		validate: ($field: any): boolean => $field.value.length > 1 && $field.value.length <= 50
	},
	inn: {
		validate($field: HTMLInputElement): boolean {
			const value = $field.inputmask?.unmaskedvalue?.() ?? $field.value;
			return /^\d{10}$/.test(value);
		},
	},
	settlementAccount: {
		validate($field: HTMLInputElement): boolean {
			const value = $field.inputmask?.unmaskedvalue?.() ?? $field.value;
			return /^\d{20}$/.test(value);
		},
	},
	ogrn: {
		validate($field: HTMLInputElement): boolean {
			const value = $field.inputmask?.unmaskedvalue?.() ?? $field.value;
			return /^\d{13}$/.test(value);
		},
	},
	bik: {
		validate($field: HTMLInputElement): boolean {
			const value = $field.inputmask?.unmaskedvalue?.() ?? $field.value;
			return /^\d{9}$/.test(value);
		},
	},
};
